import {
  addCustomerAPI,
  updateCustomerAPI,
  getCustomerSalesOrdersAPI,
  addDamageLossAdjustmentAPI,
  deleteDamageLossAdjustmentAPI,
  updateDamageLossAdjustmentAPI,
  addProductReceivingAPI,
  addProductToSalesOrderAPI,
  addStoreReturnAPI,
  addSuppliersAPI,
  addUserAPI,
  addVendorAPI,
  cancelHoldSalesOrderAPI,
  confirmOnlineSalesOrderAPI,
  createExchangeReturnAPI,
  createSalesAPI,
  deleteProductFromSalesOrderAPI,
  deleteProductReceivingAPI,
  deleteSalesOrderAPI,
  downloadReportExcelAPI,
  downloadReportPdfAPI,
  getAllCustomersAPI,
  getAllExchangeReturnOrdersAPI,
  getAllSalesAPI,
  getCampaignInventoryDetailsAPI,
  getCrossBranchInventoryAPI,
  getCustomerAPI,
  getDamageLossAdjustmentAPI,
  getExchangeReturnOrdersByIdAPI,
  getExpiredProductDetailsAPI,
  getExpiredProductsAPI,
  getInventoryDetailsAPI,
  getInvoiceDetailsAPI,
  getMedicalCategoryAPI,
  getProductDataAPI,
  getProductDetailsAPI,
  getProductDetailsByBarcodeAPI,
  getProductReceivingAPI,
  getProductSearchSuggestionsAPI,
  getProductsAPI,
  getReportAPI,
  getSalesAPI,
  getSalesOrderByInvoiceNumberAPI,
  getStatisticsAPI,
  getStocksAndBarchartDataAPI,
  getStoreReturnsAPI,
  updateStoreReturnAPI,
  deleteStoreReturnAPI,
  getStoreStatusAPI,
  getSuppliersAPI,
  getUserAPI,
  getVendorsAPI,
  returnExpiredProductsAPI,
  searchCustomersAPI,
  updatePrescriptionOrderAPI,
  updateProductDataAPI,
  updateProductFromSaleOrderAPI,
  updateProductReceivingAPI,
  updateProductReceivingStatusAPI,
  updateSalesAPI,
  updateSuppliersAPI,
  updateUserAPI,
  updateVendorAPI,
} from '../adapter/adapter'
import {
  CUSTOMER_FIELDS,
  DAMAGE_LOSS_FIELDS,
  STORE_RETURN_FIELDS,
} from '../common/constant/page-constant'

export function getSuppliersHelper() {
  let promise = new Promise(function (resolve, reject) {
    getSuppliersAPI()
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('get products Failure')
        }
      })
      .catch((err) => {
        reject('get products Failure')
      })
  })

  return promise
}

export function getExpiredProductsHelper() {
  let promise = new Promise(function (resolve, reject) {
    getExpiredProductsAPI()
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('get expired products Failure')
        }
      })
      .catch((err) => {
        reject('get expired products Failure')
      })
  })

  return promise
}

export function getExpiredProductDetailsHelper(data) {
  // let reqData = {
  //     product_receiving_detail_id: id
  // }

  let promise = new Promise(function (resolve, reject) {
    getExpiredProductDetailsAPI(data)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('get expired products Failure')
        }
      })
      .catch((err) => {
        reject('get expired products Failure')
      })
  })

  return promise
}

export function returnExpiredProductsHelper(data) {
  let reqData = {
    expired_product_id: data?.id,
    return_loss: data.returnLoss,
    amount_receivable: data.amountReceivable,
    type: data.type,
    notes: data.notes,
  }

  let promise = new Promise(function (resolve, reject) {
    returnExpiredProductsAPI(reqData)
      .then((res) => {
        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('get expired products Failure')
        }
      })
      .catch((err) => {
        reject('get expired products Failure')
      })
  })

  return promise
}

export function updateSuppliersHelper(data) {
  let promise = new Promise(function (resolve, reject) {
    updateSuppliersAPI(data)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (
          res?.data?.data &&
          res?.data?.data?.is_supplier_details_updated
        ) {
          resolve(res.data.data?.is_supplier_details_updated)
        } else {
          reject('Update Supplier Failure')
        }
      })
      .catch((err) => {
        reject('Update Supplier Failure')
      })
  })

  return promise
}

export function addSuppliersHelper(data) {
  let promise = new Promise(function (resolve, reject) {
    addSuppliersAPI(data)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data?.is_supplier_added) {
          resolve(res.data.data?.supplier_id)
        } else {
          reject('Add Supplier Failure')
        }
      })
      .catch((err) => {
        reject('Add Supplier Failure')
      })
  })

  return promise
}

export function getProductsHelper(data, signal) {
  let reqData = data

  console.log(reqData)

  let promise = new Promise(function (resolve, reject) {
    getProductsAPI(reqData, signal)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data?.products) {
          resolve(res.data.data.products)
        } else {
          reject('get products Failure')
        }
      })
      .catch((err) => {
        reject('get products Failure')
      })
  })

  return promise
}

export function getProductDataHelper(data) {
  let reqData = data

  console.log(reqData)

  let promise = new Promise(function (resolve, reject) {
    getProductDataAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('get products Failure')
        }
      })
      .catch((err) => {
        reject('get products Failure')
      })
  })

  return promise
}

export function getMedicalCategoryHelper() {
  let promise = new Promise(function (resolve, reject) {
    getMedicalCategoryAPI()
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data?.categories) {
          resolve(res.data.data?.categories)
        } else {
          reject('get products Failure')
        }
      })
      .catch((err) => {
        reject('get products Failure')
      })
  })

  return promise
}

export function updateProductDataHelper(data) {
  let reqData = data

  console.log(reqData)

  let promise = new Promise(function (resolve, reject) {
    updateProductDataAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Update products Failure !!')
        }
      })
      .catch((err) => {
        reject('Update products Failure !!')
      })
  })

  return promise
}

export function addProductReceivingHelper(data) {
  let reqData = data

  console.log(reqData)

  let promise = new Promise(function (resolve, reject) {
    addProductReceivingAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (
          res?.data?.data &&
          res?.data?.data?.is_product_receiving_added
        ) {
          resolve()
        } else {
          reject('Add Product Receiving Failure')
        }
      })
      .catch((err) => {
        reject('Add Product Receiving Failure')
      })
  })

  return promise
}

export function updateProductReceivingHelper(data) {
  let reqData = data

  console.log('updateProductReceivingHelper reqData:', reqData)

  let promise = new Promise(function (resolve, reject) {
    updateProductReceivingAPI(reqData)
      .then((res) => {
        console.log('updateProductReceivingHelper response:', res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data?.is_product_receiving_updated) {
          resolve(res.data.data)
        } else {
          reject('Update Product Receiving Failure')
        }
      })
      .catch((err) => {
        console.error('updateProductReceivingHelper error:', err)
        reject('Update Product Receiving Failure')
      })
  })

  return promise
}

export function getProductReceivingHelper(data, params) {
  let promise = new Promise(function (resolve, reject) {
    getProductReceivingAPI(data, params)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('addProductReceiving Failure')
        }
      })
      .catch((err) => {
        reject('addProductReceiving Failure')
      })
  })

  return promise
}

export function getUserHelper() {
  let promise = new Promise(function (resolve, reject) {
    getUserAPI()
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data?.users) {
          resolve(res.data.data.users)
        } else {
          reject('Add User Failure')
        }
      })
      .catch((err) => {
        reject('Add User Failure')
      })
  })

  return promise
}

export function addUserHelper(data) {
  let reqData = {
    userData: {
      name: data.userData?.name,
      designation: data.userData?.designation,
      email: data.userData?.email,
      mobile_no: data.userData?.mobileNumber,
      password: data.userData?.password,
      branch_id: data.userData?.branchId,
    },
    permissionData: data.permissionData,
  }

  console.log(reqData)

  let promise = new Promise(function (resolve, reject) {
    addUserAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data?.is_user_added) {
          resolve()
        } else {
          reject('Add User Failure !!')
        }
      })
      .catch((err) => {
        reject('Add User Failure !!')
      })
  })

  return promise
}

export function updateUserHelper(data, action) {
  let reqData = {
    action: action,
    userData: {
      user_id: data.userData?.id,
      name: data.userData?.name,
      designation: data.userData?.designation,
      email: data.userData?.email,
      mobile_no: data.userData?.mobileNumber,
      password: data.userData?.password,
      branch_id: data.userData?.branchId,
    },
    permissionData: data?.permissionData,
  }

  console.log(reqData)

  let promise = new Promise(function (resolve, reject) {
    updateUserAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data?.is_user_added) {
          resolve()
        } else {
          reject('Update User Failure !!')
        }
      })
      .catch((err) => {
        reject('Update User Failure !!')
      })
  })

  return promise
}

export function getAllCustomersHelper() {
  let promise = new Promise(function (resolve, reject) {
    getAllCustomersAPI()
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data?.customers) {
          resolve(res.data.data.customers)
        } else {
          reject('Add User Failure')
        }
      })
      .catch((err) => {
        reject('Add User Failure')
      })
  })

  return promise
}

export function getCustomerHelper(data) {
  let reqData = {
    mobile_no: data[CUSTOMER_FIELDS.PHONE_NUMBER],
  }

  console.log(reqData)

  let promise = new Promise(function (resolve, reject) {
    getCustomerAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data?.customer) {
          let customer = res.data.data.customer
          let customerDetails = {
            id: customer.id,
            [CUSTOMER_FIELDS.NAME]: customer.name,
            [CUSTOMER_FIELDS.PHONE_NUMBER]: customer.mobile_no,
            [CUSTOMER_FIELDS.BILLING_ADDRESS]: customer.billing_address,
            [CUSTOMER_FIELDS.SHIPPING_ADDRESS]: customer.shipping_address,
          }
          resolve(customerDetails)
        } else {
          reject('Get Customer Failure')
        }
      })
      .catch((err) => {
        reject('Get Customer Failure')
      })
  })

  return promise
}

export function addCustomerHelper(data) {
  let reqData = {
    name: data?.name,
    mobile_no: data?.mobileNumber,
    shipping_address: data?.shippingAddress,
    billing_address: data?.billingAddress,
    // Manual address fields
    address_type: data?.addressType || null,
    village_house: data?.villageHouse || null,
    road_block_sector: data?.roadBlockSector || null,
    division_id: data?.divisionId ? parseInt(data.divisionId) : null,
    division_name: data?.divisionName || null,
    district_id: data?.districtId ? parseInt(data.districtId) : null,
    district_name: data?.districtName || null,
    police_station_id: data?.policeStationId ? parseInt(data.policeStationId) : null,
    police_station_name: data?.policeStationName || null,
    post_office_id: data?.postOfficeId ? parseInt(data.postOfficeId) : null,
    post_office_name: data?.postOfficeName || null,
    post_code: data?.postCode || null,
  }

  console.log(reqData)

  let promise = new Promise(function (resolve, reject) {
    addCustomerAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data?.is_customer_added) {
          resolve({
            id: res.data.data.customer_id,
          })
        } else {
          reject('Add Customer Failure !!')
        }
      })
      .catch((err) => {
        reject('Add Customer Failure !!')
      })
  })

  return promise
}

export function updateCustomerHelper(data) {
  let reqData = {
    customer_id: data?.id,
    name: data?.name,
    mobile_no: data?.mobileNumber,
    shipping_address: data?.shippingAddress,
    billing_address: data?.billingAddress,
    // Manual address fields
    address_type: data?.addressType || null,
    village_house: data?.villageHouse || null,
    road_block_sector: data?.roadBlockSector || null,
    division_id: data?.divisionId ? parseInt(data.divisionId) : null,
    division_name: data?.divisionName || null,
    district_id: data?.districtId ? parseInt(data.districtId) : null,
    district_name: data?.districtName || null,
    police_station_id: data?.policeStationId ? parseInt(data.policeStationId) : null,
    police_station_name: data?.policeStationName || null,
    post_office_id: data?.postOfficeId ? parseInt(data.postOfficeId) : null,
    post_office_name: data?.postOfficeName || null,
    post_code: data?.postCode || null,
  }

  let promise = new Promise(function (resolve, reject) {
    updateCustomerAPI(reqData)
      .then((res) => {
        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data?.customer) {
          resolve(res.data.data.customer)
        } else {
          reject('Update Customer Failure !!')
        }
      })
      .catch((err) => {
        reject('Update Customer Failure !!')
      })
  })

  return promise
}

export function getCustomerSalesOrdersHelper(customerId, startDate, endDate) {
  let reqData = {
    customer_id: customerId,
  }
  
  if (startDate) {
    reqData.start_date = startDate
  }
  if (endDate) {
    reqData.end_date = endDate
  }

  let promise = new Promise(function (resolve, reject) {
    getCustomerSalesOrdersAPI(reqData)
      .then((res) => {
        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data?.sales_orders) {
          resolve(res.data.data.sales_orders)
        } else {
          reject('Get Customer Sales Orders Failure !!')
        }
      })
      .catch((err) => {
        reject('Get Customer Sales Orders Failure !!')
      })
  })

  return promise
}

export function getProductDetailsByBarcodeHelper(barcode) {
  let reqData = {
    barcode: barcode,
  }

  let promise = new Promise(function (resolve, reject) {
    getProductDetailsByBarcodeAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data?.product_detail) {
          resolve(res.data.data.product_detail)
        } else {
          reject('Get Product Details By Barcode Failure !!')
        }
      })
      .catch((err) => {
        reject('Get Product Details By Barcode Failure !!')
      })
  })

  return promise
}

export function addDamageLossAdjustmentHelper(data) {
  let reqData = {
    challan_number: data?.damageLossData?.[DAMAGE_LOSS_FIELDS.CHALLAN_NUMBER],
    product_batch_inventory_id:
      data?.damageLossData?.product_batch_inventory_id,
    quantity: data?.damageLossData?.[DAMAGE_LOSS_FIELDS.QUANTITY],
    notes: data?.damageLossData?.[DAMAGE_LOSS_FIELDS.NOTES],
    product_id: data?.productData?.product_id,
  }

  let promise = new Promise(function (resolve, reject) {
    addDamageLossAdjustmentAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (
          res?.data?.data &&
          res?.data?.data?.is_loss_adjustment_added
        ) {
          resolve()
        } else {
          reject('Add DamageLossAdjustment Failure')
        }
      })
      .catch((err) => {
        reject('Add DamageLossAdjustment Failure ', err)
      })
  })

  return promise
}

export function getDamageLossAdjustmentHelper() {
  let promise = new Promise(function (resolve, reject) {
    getDamageLossAdjustmentAPI()
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (
          res?.data?.data &&
          res?.data?.data?.damage_loss_adjustments
        ) {
          resolve(res.data.data.damage_loss_adjustments)
        } else {
          reject('get dla Failure')
        }
      })
      .catch((err) => {
        reject('get dla Failure')
      })
  })

  return promise
}

export function addStoreReturnHelper(data) {
  let reqData = {
    challan_number: data?.storeReturnData?.[STORE_RETURN_FIELDS.CHALLAN_NUMBER],
    product_batch_inventory_id:
      data?.storeReturnData?.product_batch_inventory_id,
    quantity: data?.storeReturnData?.[STORE_RETURN_FIELDS.QUANTITY],
    reason: data?.storeReturnData?.[STORE_RETURN_FIELDS.REASON],
    notes: data?.storeReturnData?.[STORE_RETURN_FIELDS.NOTES],
    product_id: data?.productData?.product_id,
  }

  let promise = new Promise(function (resolve, reject) {
    addStoreReturnAPI(reqData)
      .then((res) => {
        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data?.is_created) {
          resolve()
        } else {
          reject('Add Store Return Failure')
        }
      })
      .catch((err) => {
        reject('Add Store Return Failure')
      })
  })

  return promise
}

export function updateStoreReturnHelper(data) {
  let reqData = {
    id: data?.id,
    challan_number: data?.storeReturnData?.[STORE_RETURN_FIELDS.CHALLAN_NUMBER],
    product_batch_inventory_id:
      data?.storeReturnData?.product_batch_inventory_id,
    quantity: data?.storeReturnData?.[STORE_RETURN_FIELDS.QUANTITY],
    reason: data?.storeReturnData?.[STORE_RETURN_FIELDS.REASON],
    notes: data?.storeReturnData?.[STORE_RETURN_FIELDS.NOTES],
    product_id: data?.productData?.product_id,
  }

  let promise = new Promise(function (resolve, reject) {
    updateStoreReturnAPI(reqData)
      .then((res) => {
        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data?.is_updated) {
          resolve()
        } else {
          reject('Update Store Return Failure')
        }
      })
      .catch((err) => {
        reject('Update Store Return Failure')
      })
  })

  return promise
}

export function deleteStoreReturnHelper(id) {
  let promise = new Promise(function (resolve, reject) {
    deleteStoreReturnAPI(id)
      .then((res) => {
        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data?.is_deleted) {
          resolve()
        } else {
          reject('Delete Store Return Failure')
        }
      })
      .catch((err) => {
        reject('Delete Store Return Failure')
      })
  })

  return promise
}

export function getStoreReturnsHelper() {
  let promise = new Promise(function (resolve, reject) {
    getStoreReturnsAPI()
      .then((res) => {
        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (
          res?.data?.data &&
          res?.data?.data?.store_returns
        ) {
          resolve(res.data.data.store_returns)
        } else {
          reject('get Store Returns Failure')
        }
      })
      .catch((err) => {
        reject('get Store Returns Failure')
      })
  })

  return promise
}

export function deleteDamageLossAdjustmentHelper(challanNumber) {
  let promise = new Promise(function (resolve, reject) {
    deleteDamageLossAdjustmentAPI({ challan_number: challanNumber })
      .then((res) => {
        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (
          res?.data?.data &&
          res?.data?.data?.is_damage_loss_deleted
        ) {
          resolve()
        } else {
          reject('Delete Damage/Loss Adjustment Failure')
        }
      })
      .catch((err) => {
        reject('Delete Damage/Loss Adjustment Failure')
      })
  })

  return promise
}

export function updateDamageLossAdjustmentHelper(data) {
  let promise = new Promise(function (resolve, reject) {
    updateDamageLossAdjustmentAPI(data)
      .then((res) => {
        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (
          res?.data?.data &&
          res?.data?.data?.is_damage_loss_updated
        ) {
          resolve()
        } else {
          reject('Update Damage/Loss Adjustment Failure')
        }
      })
      .catch((err) => {
        reject('Update Damage/Loss Adjustment Failure')
      })
  })

  return promise
}

export function getInventoryDetailsHelper(data, params) {
  let promise = new Promise(function (resolve, reject) {
    getInventoryDetailsAPI(data, params)
      .then((res) => {
        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Add Customer Failure')
        }
      })
      .catch((err) => {
        reject('Add Customer Failure')
      })
  })

  return promise
}

export function getCrossBranchInventoryHelper(data) {
  let promise = new Promise(function (resolve, reject) {
    getCrossBranchInventoryAPI(data)
      .then((res) => {
        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Get Cross Branch Inventory Failure')
        }
      })
      .catch((err) => {
        reject('Get Cross Branch Inventory Failure')
      })
  })

  return promise
}

export function getCampaignInventoryDetailsHelper() {
  let promise = new Promise(function (resolve, reject) {
    getCampaignInventoryDetailsAPI()
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data?.inventory) {
          resolve(res.data.data.inventory)
        } else {
          reject('Add Customer Failure')
        }
      })
      .catch((err) => {
        reject('Add Customer Failure')
      })
  })

  return promise
}

export function getProductDetailsHelper(id) {
  let reqData = {
    product_id: id,
  }

  console.log(reqData)

  let promise = new Promise(function (resolve, reject) {
    getProductDetailsAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data?.product_details) {
          resolve(res.data.data.product_details)
        } else {
          reject('Add Customer Failure')
        }
      })
      .catch((err) => {
        reject('Add Customer Failure')
      })
  })

  return promise
}

export function getInvoiceDetailsHelper(id) {
  let reqData = {
    product_receiving_id: id,
  }

  console.log(reqData)

  let promise = new Promise(function (resolve, reject) {
    getInvoiceDetailsAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data?.product_receiving) {
          resolve(res.data.data.product_receiving)
        } else {
          reject('Add Customer Failure')
        }
      })
      .catch((err) => {
        reject('Add Customer Failure')
      })
  })

  return promise
}

export function getAllSalesOrderHelper(filters) {
  // Send filters in request body
  const reqData = {
    page: filters?.page || 1,
    limit: filters?.limit || 50,
  }

  // Add optional filters
  if (filters?.status) {
    reqData.status = filters.status
  }
  if (filters?.type) {
    reqData.type = filters.type
  }
  if (filters?.invoice_number) {
    reqData.invoice_number = filters.invoice_number
  }

  console.log('getAllSalesOrderHelper request:', reqData)

  return new Promise((resolve, reject) => {
    getAllSalesAPI(reqData)
      .then((res) => {
        console.log('getAllSalesOrderHelper response:', res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Get Sales Orders Failure')
        }
      })
      .catch((err) => {
        console.error('getAllSalesOrderHelper error:', err)
        reject('Get Sales Orders Failure')
      })
  })
}
export function getSalesOrderHelper(id) {
  let reqData = {
    sales_order_id: id,
  }

  console.log(reqData)

  let promise = new Promise(function (resolve, reject) {
    getSalesAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data.sales_order) {
          resolve(res.data?.data.sales_order)
        } else {
          reject('Get Customer Failure')
        }
      })
      .catch((err) => {
        reject('Get Customer Failure')
      })
  })

  return promise
}

export function createSalesHelper(data) {
  let reqData = {
    status: data.status,
    customer_details: data.customerDetails,
    product_details: data.productDetails,
    payment_details: data.paymentDetails,
  }

  console.log('createSalesHelper request:', reqData)

  let promise = new Promise(function (resolve, reject) {
    createSalesAPI(reqData)
      .then((res) => {
        console.log('createSalesHelper response:', res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data?.is_created) {
          // Return the sales order data including ID for printing
          const salesData = res.data.data
          resolve({
            id: salesData.sales_order_id || salesData.id,
            invoice_number: salesData.invoice_number,
            ...salesData
          })
        } else {
          reject('Create Sales Failure !!')
        }
      })
      .catch((err) => {
        console.error('createSalesHelper error:', err)
        reject('Create Sales Failure !!')
      })
  })

  return promise
}

export function updateSalesHelper(data) {
  let reqData = {
    sales_order_id: data.id,
    product_details: data.productDetails,
    payment_details: data.paymentDetails,
  }

  console.log('updateSalesHelper request:', reqData)

  let promise = new Promise(function (resolve, reject) {
    updateSalesAPI(reqData)
      .then((res) => {
        console.log('updateSalesHelper response:', res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data?.is_sales_order_updated) {
          // Return the sales order ID for printing
          resolve({
            id: data.id,
            ...res.data.data
          })
        } else {
          reject('Update Sales Failure')
        }
      })
      .catch((err) => {
        console.error('updateSalesHelper error:', err)
        reject('Update Sales Failure')
      })
  })

  return promise
}

export function getSalesOrderByInvoiceNumberHelper(id) {
  let reqData = {
    invoice_number: id,
  }

  console.log(reqData)

  let promise = new Promise(function (resolve, reject) {
    getSalesOrderByInvoiceNumberAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data.sales_order) {
          resolve(res.data?.data.sales_order)
        } else {
          reject('Get Sales By InvoiceNumber Failure !!')
        }
      })
      .catch((err) => {
        reject('Get Sales By InvoiceNumber Failure !!')
      })
  })

  return promise
}

export function createExchangeReturnHelper(data) {
  let reqData = {
    sales_order_id: data.salesOrderId,
    reason_type: data.addExchangeReturnFlow,
    customer_details: data.customerDetails,
    old_product_details: data.oldProductDetailsArray,
    new_product_details: data.newProductDetailsArray,
    payment_details: data.paymentDetails,
  }

  console.log(reqData)

  let promise = new Promise(function (resolve, reject) {
    createExchangeReturnAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data?.is_created) {
          resolve()
        } else {
          reject('Add Exchange Return Failure')
        }
      })
      .catch((err) => {
        reject('Add Exchange Return Failure')
      })
  })

  return promise
}

export function getAllExchangeReturnOrdersHelper(data, params) {
  return new Promise((resolve, reject) => {
    getAllExchangeReturnOrdersAPI(data, params)
      .then((res) => {
        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (
          res?.data?.data &&
          res?.data?.data?.exchange_or_return_sales_orders
        ) {
          resolve({
            orders: res.data.data.exchange_or_return_sales_orders,
            pagination: res.data.data.pagination,
          })
        } else {
          reject('Add Exchange Return Orders Failure')
        }
      })
      .catch(() => {
        reject('Add Exchange Return Orders Failure')
      })
  })
}

export function getExchangeReturnOrderByIdHelper(id) {
  let reqData = {
    exchange_or_return_sales_order_id: id,
  }
  let promise = new Promise(function (resolve, reject) {
    getExchangeReturnOrdersByIdAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (
          res?.data?.data &&
          res?.data?.data?.exchange_or_return_sales_order
        ) {
          resolve(res.data.data.exchange_or_return_sales_order)
        } else {
          reject('Add Exchange Return Orders Failure')
        }
      })
      .catch((err) => {
        reject('Add Exchange Return Orders Failure')
      })
  })

  return promise
}

export function confirmOnlineSalesOrderHelper(data) {
  let reqData = {
    sales_order_id: data.id,
    delivery_partner_id: data.deliveryPartnerId,
    status: data.status,
  }
  let promise = new Promise(function (resolve, reject) {
    confirmOnlineSalesOrderAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Confirm Sales Failure !!')
        }
      })
      .catch((err) => {
        reject('Confirm Sales Failure !!')
      })
  })

  return promise
}

export function deleteSalesOrderHelper(salesOrderId) {
  let promise = new Promise(function (resolve, reject) {
    deleteSalesOrderAPI(salesOrderId)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Delete Sales Order Failure !!')
        }
      })
      .catch((err) => {
        reject('Delete Sales Order Failure !!')
      })
  })

  return promise
}

export function addProductToSalesOrderHelper(salesOrderId, data) {
  let promise = new Promise(function (resolve, reject) {
    addProductToSalesOrderAPI(salesOrderId, data)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Add Product to Sales Order Failure !!')
        }
      })
      .catch((err) => {
        reject('Add Product to Sales Order Failure !!')
      })
  })

  return promise
}

export function updateProductToSalesOrderHelper(salesOrderId, itemId, data) {
  let promise = new Promise(function (resolve, reject) {
    updateProductFromSaleOrderAPI(salesOrderId, itemId, data)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Update Product in Sales Order Failure !!')
        }
      })
      .catch((err) => {
        reject('Update Product in Sales Order Failure !!')
      })
  })

  return promise
}

export function deleteProductFromSalesOrderHelper(salesOrderId, itemId) {
  let promise = new Promise(function (resolve, reject) {
    deleteProductFromSalesOrderAPI(salesOrderId, itemId)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Delete Product from Sales Order Failure !!')
        }
      })
      .catch((err) => {
        reject('Delete Product from Sales Order Failure !!')
      })
  })

  return promise
}

export function cancelSalesHelper(salesOrderId) {
  let reqData = {
    sales_order_id: salesOrderId,
  }

  console.log('cancelSalesHelper request:', reqData)

  let promise = new Promise(function (resolve, reject) {
    // Use cancelHoldSalesOrderAPI for cancelling HOLD/Draft orders
    cancelHoldSalesOrderAPI(reqData)
      .then((res) => {
        console.log('cancelSalesHelper response:', res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Cancel Sales Failure !!')
        }
      })
      .catch((err) => {
        console.error('cancelSalesHelper error:', err)
        reject('Cancel Sales Failure !!')
      })
  })

  return promise
}

export function getStatisticsHelper(data) {
  let promise = new Promise(function (resolve, reject) {
    getStatisticsAPI()
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('get Stats Failure !!')
        }
      })
      .catch((err) => {
        reject('get Stats Failure !!')
      })
  })

  return promise
}

export const getStoreStatusHelper = () => {
  let promise = new Promise(function (resolve, reject) {
    getStoreStatusAPI()
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('get Store Status Failure !!')
        }
      })
      .catch((err) => {
        reject('get Store Status Failure !!')
      })
  })

  return promise
}

export function getStocksAndBarchartDataHelper(data) {
  let promise = new Promise(function (resolve, reject) {
    getStocksAndBarchartDataAPI()
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('get Stocks Failure !!')
        }
      })
      .catch((err) => {
        reject('get Stocks Failure !!')
      })
  })

  return promise
}

export function updatePrescriptionOrderHelper(data) {
  let reqData = {
    order_id: data.orderId,
    product_details: data.productDetails,
    payment_details: data.paymentDetails,
  }

  let promise = new Promise(function (resolve, reject) {
    updatePrescriptionOrderAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('update Prescription Order Failure !!')
        }
      })
      .catch((err) => {
        reject('update Prescription Order Failure !!')
      })
  })

  return promise
}

export function getReportHelper(data) {
  let reqData = {
    start_date: data.startDate,
    end_date: data.endDate,
    type: data.reportType,
    sub_type: data.subType,
  }

  // Add branch filter parameters
  if (data.allBranches) {
    reqData.all_branches = true
  } else if (data.branchId) {
    reqData.branch_id = data.branchId
  }

  let promise = new Promise(function (resolve, reject) {
    getReportAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('get Reports Failure !!')
        }
      })
      .catch((err) => {
        reject('get Reports Failure !!')
      })
  })

  return promise
}

export function downloadReportPdfHelper(data) {
  let reqData = {
    start_date: data.startDate,
    end_date: data.endDate,
    type: data.reportType,
    sub_type: data.subType,
  }

  // Add branch filter parameters
  if (data.allBranches) {
    reqData.all_branches = true
    reqData.branch_name = 'All Branches'
  } else if (data.branchId) {
    reqData.branch_id = data.branchId
    if (data.branchName) {
      reqData.branch_name = data.branchName
    }
  }

  // Add optional filter parameters if they exist
  if (data.pharmacySupplierId) {
    reqData.pharmacy_supplier_id = data.pharmacySupplierId // Use the correct parameter name
  }

  if (data.productType) {
    reqData.product_type = data.productType
  }

  if (data.genericName) {
    reqData.generic_name = data.genericName
  }

  if (data.salesMan) {
    reqData.sales_man = data.salesMan
  }

  let promise = new Promise(function (resolve, reject) {
    downloadReportPdfAPI(reqData)
      .then((res) => {
        console.log(res.data)

        try {
          const blob = new Blob([res.data], {
            type: res.headers['content-type'],
          })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.setAttribute(
            'download',
            `${data.reportType}_${data.subType}.pdf`
          )
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

          resolve()
        } catch (err) {
          reject('download Reports Failure !!')
        }
      })
      .catch((err) => {
        reject('download Reports Failure !!')
      })
  })

  return promise
}

export function downloadReportExcelHelper(data) {
  let reqData = {
    start_date: data.startDate,
    end_date: data.endDate,
    type: data.reportType,
    sub_type: data.subType,
  }

  // Add branch filter parameters
  if (data.allBranches) {
    reqData.all_branches = true
    reqData.branch_name = 'All Branches'
  } else if (data.branchId) {
    reqData.branch_id = data.branchId
    if (data.branchName) {
      reqData.branch_name = data.branchName
    }
  }

  if (data.pharmacySupplierId) {
    reqData.pharmacy_supplier_id = data.pharmacySupplierId
  }

  if (data.productType) {
    reqData.product_type = data.productType
  }

  if (data.genericName) {
    reqData.generic_name = data.genericName
  }

  if (data.salesMan) {
    reqData.sales_man = data.salesMan
  }

  let promise = new Promise(function (resolve, reject) {
    downloadReportExcelAPI(reqData)
      .then((res) => {
        console.log(res.data)

        try {
          const blob = new Blob([res.data], {
            type: res.headers['content-type'],
          })
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.setAttribute(
            'download',
            `${data.reportType}_${data.subType}.csv`
          )
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)

          resolve()
        } catch (err) {
          reject('download Reports Failure !!')
        }
      })
      .catch((err) => {
        reject('download Reports Failure !!')
      })
  })

  return promise
}

// ============ Product Receiving Enhancement Functions ============

export function getVendorsHelper() {
  let promise = new Promise(function (resolve, reject) {
    getVendorsAPI()
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Get Vendors Failure')
        }
      })
      .catch((err) => {
        reject('Get Vendors Failure')
      })
  })

  return promise
}

export function addVendorHelper(data) {
  let promise = new Promise(function (resolve, reject) {
    addVendorAPI(data)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Add Vendor Failure')
        }
      })
      .catch((err) => {
        reject('Add Vendor Failure')
      })
  })

  return promise
}

export function updateVendorHelper(data) {
  let promise = new Promise(function (resolve, reject) {
    updateVendorAPI(data)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data) {
          resolve(res.data.data)
        } else {
          reject('Update Vendor Failure')
        }
      })
      .catch((err) => {
        reject('Update Vendor Failure')
      })
  })

  return promise
}

export function getBranchProductsHelper() {
  let reqData = {
    search_string: ''
  }

  let promise = new Promise(function (resolve, reject) {
    getProductSearchSuggestionsAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data?.search_suggestions) {
          resolve(res.data.data.search_suggestions)
        } else {
          resolve([])
        }
      })
      .catch((err) => {
        console.log('Get branch products error:', err)
        resolve([])
      })
  })

  return promise
}

export function searchCustomersHelper(searchString) {
  let reqData = {
    search_string: searchString
  }

  console.log(reqData)

  let promise = new Promise(function (resolve, reject) {
    searchCustomersAPI(reqData)
      .then((res) => {
        console.log(res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data?.customers) {
          let customers = res.data.data.customers.map((customer) => ({
            id: customer.id,
            name: customer.name,
            phone: customer.mobile_no,
            mobile_no: customer.mobile_no,
            address: customer.billing_address || customer.shipping_address,
            billing_address: customer.billing_address,
            shipping_address: customer.shipping_address
          }))
          resolve(customers)
        } else {
          resolve([])
        }
      })
      .catch((err) => {
        reject('Search Customers Failure')
      })
  })

  return promise
}

export function updateProductReceivingStatusHelper(data) {
  let reqData = data

  console.log('updateProductReceivingStatusHelper reqData:', reqData)

  let promise = new Promise(function (resolve, reject) {
    updateProductReceivingStatusAPI(reqData)
      .then((res) => {
        console.log('updateProductReceivingStatusHelper response:', res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data?.is_status_updated) {
          resolve(res.data.data)
        } else {
          reject('Update Product Receiving Status Failure')
        }
      })
      .catch((err) => {
        console.error('updateProductReceivingStatusHelper error:', err)
        reject('Update Product Receiving Status Failure')
      })
  })

  return promise
}

export function deleteProductReceivingHelper(data) {
  let reqData = data
  console.log('deleteProductReceivingHelper reqData:', reqData)

  let promise = new Promise(function (resolve, reject) {
    deleteProductReceivingAPI(reqData)
      .then((res) => {
        console.log('deleteProductReceivingHelper response:', res.data)

        if (res?.data?.error) {
          reject(res.data.error.message)
        } else if (res?.data?.data && res?.data?.data?.is_deleted) {
          resolve(res.data.data)
        } else {
          reject('Delete Product Receiving Failure')
        }
      })
      .catch((err) => {
        console.error('deleteProductReceivingHelper error:', err)
        reject('Delete Product Receiving Failure')
      })
  })

  return promise
}
